var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 24.675L21.3333 24.675L21.3333 16.675L18.6667 16.675L18.6667 24.675ZM2.66667 24.675L5.33333 24.675L5.33333 11.3417L2.66667 11.3417L2.66667 24.675ZM24 11.3417L21.3333 11.3417L21.3333 0.675048L18.6667 0.675048L18.6667 11.3417L16 11.3417L16 14.0084L24 14.0084L24 11.3417ZM8 19.3417L10.6667 19.3417L10.6667 24.675L13.3333 24.675L13.3333 19.3417L16 19.3417L16 16.675L8 16.675L8 19.3417ZM13.3333 0.675048L10.6667 0.675048L10.6667 14.0084L13.3333 14.0084L13.3333 0.675048ZM8 8.67505L8 6.00838L5.33333 6.00838L5.33333 0.675049L2.66667 0.675049L2.66667 6.00838L-8.15946e-07 6.00838L-6.99382e-07 8.67505L8 8.67505Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.429a01a42b3e6c29824bdbe5f41230dd.svg";
export { ForwardRef as ReactComponent };